// extracted by mini-css-extract-plugin
module.exports = {"DeviceDynamicPicWrapper":"DeviceDynamicPic_DeviceDynamicPicWrapper__Vctod"};